// Mock data for Sinyal Bank Entry Landing Page

export const stats = [
  {
    id: 1,
    label: "Total Klien Terdaftar",
    value: "21,227",
    subtitle: "sepanjang 2025"
  },
  {
    id: 2,
    label: "Total Klien Aktif",
    value: "627",
    subtitle: ""
  },
  {
    id: 3,
    label: "Sinyal Harian yang Dihasilkan",
    value: "1,100",
    subtitle: "(Rata-rata 5 sinyal per harian)"
  },
  {
    id: 4,
    label: "Rata-rata Winrate",
    value: "83%",
    subtitle: ""
  }
];

export const features = [
  {
    id: 1,
    icon: "brain",
    title: "AI-Powered Market Insights",
    description: "Gak perlu capek nebak-nebak pergerakan pasar. Indikator SBE kasih analisis data otomatis buat bantu kalian ambil keputusan terbaik"
  },
  {
    id: 2,
    icon: "zap",
    title: "Sinyal Real-Time dengan Win Rate Tinggi",
    description: "Gak perlu lama-lama nunggu momen entry. Sinyal & alert langsung muncul begitu ada peluang"
  },
  {
    id: 3,
    icon: "shield",
    title: "Manajemen Risiko yang Dipersonalisasi",
    description: "Strategi trading diatur sesuai dengan gaya risiko kalian"
  },
  {
    id: 4,
    icon: "graduationCap",
    title: "Pembelajaran Interaktif & Peningkatan Berkelanjutan",
    description: "Belajar trading jadi seru dengan kuis dan modul interaktif. Skill kalian bakal terus naik level!"
  },
  {
    id: 5,
    icon: "layout",
    title: "Interface Lengkap tapi Mudah Dipakai",
    description: "Semua fitur canggih ada, tapi tampilannya simpel dan ramah di mata, bikin trading lebih nyaman"
  },
  {
    id: 6,
    icon: "clock",
    title: "Otomasi Hemat Waktu",
    description: "Biar kalian gak harus mantengin market 24/7, serahkan ke sistem Indikator SBE yang bakal kasih notifikasi & analisis"
  }
];

export const painPoints = [
  "Kurang yakin sama analisa sendiri",
  "Analisa chart kadang gak jelas",
  "Susah atur emosi saat trading",
  "Belum punya strategi trading yang bener",
  "Minim support & bimbingan yang pas",
  "Kurang pengetahuan atau rasa percaya diri"
];

export const systemFeatures = [
  {
    id: 1,
    title: "Precision Trading",
    description: "kalian bisa mendeteksi zona support dan resistance dengan akurasi lebih tinggi"
  },
  {
    id: 2,
    title: "Market Overview & Sinyal yang Mudah Dibaca",
    description: "Bikin keputusan lebih gampang, cocok buat pemula maupun pro"
  },
  {
    id: 3,
    title: "Hemat waktu & waktu ke Trading",
    description: "Gak perlu mantau market 24/7, risiko kelewatan entry jadi minimal"
  },
  {
    id: 4,
    title: "Multiple Timeframe & Pairs",
    description: "Indikator SBE bisa digunakan untuk berbagai pasangan mata uang selain Gold, dan memungkinkan pemilihan timeframe"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Nathan",
    message: "Berhasil flip account dari $40 ke $1118 pakai Indikator SBE. Luar biasa!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah",
    message: "Indikator SBE bikin trading jadi lebih mudah dan efisien. Recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Budi",
    message: "Winrate naik drastis sejak pakai Indikator SBE. Trading jadi lebih tenang.",
    rating: 5
  },
  {
    id: 4,
    name: "Dina",
    message: "Fitur-fiturnya lengkap dan mudah digunakan. Cocok buat pemula!",
    rating: 5
  }
];

export const traderStories = [
  {
    id: 1,
    name: "Rudi",
    age: 28,
    occupation: "Karyawan swasta",
    location: "Surabaya",
    story: [
      "Dulu gue cuma modal 500 ribu buat trading. Setiap hari MC terus, sampe gue mikir mau nyerah aja...",
      "Terus gue nemu Indikator SBE dari temen kantor. Awalnya skeptis, tapi desperate butuh solusi. Pas coba, baru seminggu udah bisa profit konsisten 2 juta per hari!"
    ],
    results: [
      "Modal 500rb → Sekarang 2 juta",
      "Win rate naik dari 40% → 78%",
      "Gak pernah MC lagi sejak pakai SBE"
    ],
    closing: "Kalau gue bisa, kalian pasti bisa juga. Jangan sia-siain kesempatan ini kayak gue dulu yang telat tau Indikator SBE!",
    proofImage: "/trading-results.jpg"
  },
  {
    id: 2,
    name: "Ani",
    age: 32,
    occupation: "Ibu rumah tangga",
    location: "Jakarta",
    story: [
      "Sebagai ibu rumah tangga, gue pengen bantu suami tapi gak bisa kerja kantoran. Trading jadi pilihan, tapi awalnya rugi melulu.",
      "Untung ada Indikator SBE! Sekarang gue bisa trading sambil jaga anak. Sinyal jelas, gak perlu analisa ribet. Dalam 2 bulan, udah bisa tambah penghasilan keluarga 5 juta sebulan!"
    ],
    results: [
      "Dari rugi 2 juta → Profit konsisten 5 juta/bulan",
      "Trading cuma 2-3 jam per hari",
      "Tetap bisa fokus sama keluarga"
    ],
    closing: "Indikator SBE bener-bener game changer buat ibu rumah tangga yang mau punya penghasilan sendiri!",
    proofImage: "/trading-ani.jpg"
  },
  {
    id: 3,
    name: "Dika",
    age: 25,
    occupation: "Fresh graduate",
    location: "Bandung",
    story: [
      "Baru lulus kuliah, susah dapat kerja. Gue coba trading dengan modal tabungan 1 juta. Awalnya MC 3 kali berturut-turut, modal tinggal 200 ribu.",
      "Nyaris putus asa, tapi nemu Indikator SBE di komuniti Telegram. Gue all-in modal sisa gue. Dalam sebulan, modal gue balik lagi ke 1 juta. Bulan kedua udah 5 juta!"
    ],
    results: [
      "Dari modal 200 ribu → Sekarang 15 juta",
      "Win rate 75% konsisten",
      "Sekarang jadi full-time trader"
    ],
    closing: "Buat yang baru lulus dan susah cari kerja, trading pakai Indikator SBE bisa jadi solusi. Gue buktinya!",
    proofImage: "/trading-dika.jpg"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Apakah Indikator SBE cocok untuk pemula dan trader pro?",
    answer: "Indikator SBE mudah digunakan dan dipahami. Dirancang untuk semua level trader, dari pemula hingga yang sudah pro, sehingga siapa pun bisa memanfaatkannya dengan maksimal."
  },
  {
    id: 2,
    question: "Apakah bisa membatalkan langganan kapan saja?",
    answer: "Indikator SBE menggunakan sistem pembayaran one-time payment. Tidak ada biaya berlangganan bulanan, jadi kamu hanya perlu bayar sekali tanpa harus khawatir dengan pembayaran selanjutnya."
  },
  {
    id: 3,
    question: "Seberapa sering trade signals keluar?",
    answer: "Indikator SBE mengeluarkan sinyal berdasarkan Support and Resistance (SNR) dan trendline. Sinyal muncul saat harga mendekati atau melintasi level SNR, atau ketika harga berada di sekitar garis tren, menunjukkan potensi pembalikan atau kelanjutan trend."
  },
  {
    id: 4,
    question: "Apa Indikator SBE bisa dipakai selain pair gold?",
    answer: "Indikator SBE bisa dipakai di semua pair, nggak terbatas cuma di gold. Mau trading di Forex, Index, atau Crypto? Tinggal pilih pair yang lo mau, dan indikator langsung siap bantu analisa. Gampang banget, kan?"
  },
  {
    id: 5,
    question: "Apa keunggulan Indikator SBE dibandingkan indikator lain di pasaran?",
    answer: "Indikator SBE menawarkan data yang lebih lengkap dengan menggabungkan analisis dari berbagai sumber, fleksibel digunakan di semua pair, dan memberikan sinyal yang lebih akurat. Dirancang simpel dan mudah digunakan, cocok untuk pemula dan profesional. Dilengkapi juga dengan dukungan lengkap untuk memaksimalkan hasil trading."
  }
];

export const comparisonData = {
  indicator: [
    "Tergantung pada interpretasi manual",
    "Sinyal bisa delay atau false",
    "Butuh pengalaman untuk membaca dengan benar",
    "Tidak ada context dari berita atau sentimen",
    "Analisis terbatas pada chart saja"
  ],
  sbe: [
    "Konfirmasi Arah Market Secara RealTime",
    "High win rate",
    "Deteksi Awal Pembalikan Trend lewat trendline",
    "Cocok untuk Scalper, Intraday, dan Swing",
    "Otomatis Menandai Zona SnR Berkualitas Tinggi"
  ]
};